import React, { useState, useEffect } from 'react';
import posed from 'react-pose';
import { HubConnectionBuilder } from '@aspnet/signalr';
import s from './Page.module.scss';
import Blocks from './Blocks';
import Intro from './Intro/Intro';
import Notification from '../Components/Notification/Notification';
import Social from '../Components/Social/Social';

const NotificationPose = posed.div({
  enter: { opacity: 1, x: 220, transition: { duration: 250 } },
  exit: {
    opacity: 0,
    x: 0,
    transition: { duration: 250 }
  }
});

let timerNotification;

const Page = () => {
  const [showNotification, setShowNotification] = useState(true);
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    const connection = new HubConnectionBuilder()
      .withUrl(`${window.config.ENDPOINT}/signalR/gameResults`)
      .build();

    connection.on('NewGameResult', result => setNotification(result));

    connection.start();
  }, []);

  useEffect(() => {
    if (notification) {
      setShowNotification(true);
      clearTimeout(timerNotification);
      timerNotification = setTimeout(() => {
        setShowNotification(false);
      }, 5000);
    }
  }, [notification]);

  return (
    <div className={s.container}>
      <Intro />
      <Blocks notification={notification}/>
      <Social />
      <NotificationPose
        key={1}
        className={s.notification}
        pose={showNotification ? 'enter' : 'exit'}
      >
        {notification && (
          <Notification
            gameType={notification.current.gameType}
            time={notification.current.timeMilliseconds}
            score={notification.current.score}
            userMaskedEmail={notification.userMaskedEmail}
          />
        )}
      </NotificationPose>
    </div>
  );
};

export default Page;
